import classNames from 'classnames'

import { Modal } from '@material-ui/core'

import styles from './ModalFrame.module.scss'

const ModalFrame = ({
  children,
  className,
  hideModal,
  isSubmitting = false,
  scrollable = false
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' && isSubmitting) return
    if (!isSubmitting) hideModal()
  }

  return (
    <Modal
      open
      onClose={handleClose}
    >
      <div className={classNames(styles.overlay, { [styles.scrollable]: scrollable })}>
        <div className={classNames(styles.modal, className)}>{children}</div>
      </div>
    </Modal>
  )
}

export default ModalFrame
